const agePreferences = [
  { name: "18-29", value: "A18_29" },
  { name: "30-44", value: "A30_44" },
  { name: "45-54", value: "A45_54" },
  { name: "55+", value: "A55_PLUS" },
  { name: "No preference", value: "NO_PREFERENCE" },
];

export default agePreferences;
